"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.virtualGraduationEventDefaultFields = void 0;
exports.virtualGraduationEventDefaultFields = {
    slide: false,
    survey: false,
    surveyLink: null,
    marchingOrderId: null,
    snapchat: false,
    snapcodes: [],
    invitationDate: null,
    deadlineDate: null,
    emails: {
        invitation: false,
        reminder: false,
        secondReminder: false,
        rejection: false,
        confirmation: false,
        invitationTemplateId: null,
        reminderTemplateId: null,
        secondReminderTemplateId: null,
        rejectionTemplateId: null,
        confirmationTemplateId: null,
    },
};
//# sourceMappingURL=reset-event.js.map